// ---------------------------------------------------------------------------------
// Multi-Pair Sync helper – wraps the MultiPairSync contract
// ---------------------------------------------------------------------------------
import Web3 from 'web3';
import multiPairSyncAbi from '../../contracts/multiPairSyncAbi';

// address of the deployed MultiPairSync contract
export const MULTI_PAIR_SYNC_ADDR = '0x8aF37124949884Dc57eEE2741B57DF65f336ddf6';

/** return a web3 Contract instance that uses the app's provider */
export const getSyncContract = (provider) => {
  const web3 = new Web3(provider);
  return new web3.eth.Contract(multiPairSyncAbi, MULTI_PAIR_SYNC_ADDR);
};

/** sync a single LP pair for the caller */
export const syncPositionForPair = async ({ provider, account, pair }) => {
  const contract = getSyncContract(provider);
  return contract.methods.syncPositionForPair(pair).send({ from: account });
};

/** sync MANY LP pairs for the caller */
export const syncMultiplePairs = async ({ provider, account, pairs }) => {
  const contract = getSyncContract(provider);
  return contract.methods.syncMultiplePairs(pairs).send({ from: account });
};
